module.exports = __webpack_public_path__ + "img/banner_text_3.bccfbff6.png";